import { VuexModule, Module, MutationAction, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { getToken, setToken, removeToken } from '@/utils/auth';
import { loginInfo } from '@/api/user';
import utils from '@/utils/utils';
import { userRoleList } from '@/api/setting';

export interface IUserState {
  token: string;
  name: string;
  avatar: string;
  permissions: string[];
  dataPermission: string;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  phone: string;
  remark: string;
  roleId: number;
  userId: number;
  roleName: string;
  staffId: string;
  roles: string[];
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public token = '';
  public name = '';
  public avatar = '';
  public roles: Array<any> = [];
  public permissions: string[] = [];
  public dataPermission: string = '';
  public isAdmin: boolean = false;
  public isSuperAdmin: boolean = false;
  public isExternalShipper: boolean = false;
  public phone: string = '';
  public remark: string = '';
  public roleId: number = 0;
  public roleName: string = '';
  public userId: number = 0;
  public staffId: string = '';
  

  get userInfo() {
    return {
      name: this.name,
      phone: this.phone,
      dataPermission: this.dataPermission,
      roleName: this.roleName
    };
  }

  @Action({ commit: 'SET_TOKEN', rawError: true })
  public async Login(token: string) {
    if (utils.jwtParse(token)) {
      setToken(token);
      return token;
    }
  }

  /**获取角色列表 */
  @Action({ commit: 'SET_ROLELIST' })
  public async RoleList() {
    let data = await userRoleList();
    return data;
  }

  @Mutation
  private SET_ROLELIST(result: any) {
    this.roles = result.items;
  }

  @MutationAction({ mutate: ['roles'] })
  public async GetRoles() {
    return {
      roles: this.roles
    };
  }

  /**退出登录 */
  @Action({ commit: 'SET_TOKEN' })
  public async FedLogOut() {
    removeToken();
    return '';
  }
  // 'staffId',
  @MutationAction({ mutate: ['dataPermission', 'isAdmin', 'isSuperAdmin', 'staffId', 'name', 'phone', 'remark', 'roleId', 'userId', 'roleName', 'avatar', 'permissions','isExternalShipper'] }) //'roles', 'name', 'avatar', 'token'
  public async GetUserInfo() {
    const token = getToken();
    if (token === undefined) {
      throw Error('GetUserInfo: token is undefined!');
    }
    let data: any = await loginInfo();
    return {
      avatar: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=480194109,2955193021&fm=27&gp=0.jpg',
      ...data
    };
  }
}

export const UserStore = getModule(User);
